import apiClient from "@/services/apiClient";

/** @typedef {import("@/APIVO/Student/IStudentDocumentWorkflowActionRequest").IStudentDocumentWorkflowActionRequest} IStudentDocumentWorkflowActionRequest */
/** @typedef {import("@/APIVO/Student/IStudentEnrollmentDocumentSubmitRequest").IStudentEnrollmentDocumentSubmitRequest} IStudentEnrollmentDocumentSubmitRequest */

const client = apiClient;

export const studentDocumentsService = {
  getDocuments: async () => {
    const response = await client.get("/StudentDocuments");
    return response.data;
  },

  getEnrollmentDocuments: async (studentEnrollmentId) => {
    const response = await client.get("/StudentDocuments/enrollment", {
      params: studentEnrollmentId ? { studentEnrollmentId } : undefined,
    });
    return response.data;
  },

  upload: async (values, onUploadProgress) => {
    const formData = new FormData();
    formData.append("StudentDocTypeId", String(values.studentDocTypeId));
    if (values.studentEnrollmentId) formData.append("StudentEnrollmentId", String(values.studentEnrollmentId));
    if (values.issueDate) formData.append("IssueDate", values.issueDate);
    if (values.expiryDate) formData.append("ExpiryDate", values.expiryDate);
    if (values.remarks) formData.append("Remarks", values.remarks);
    if (values.documentDescription) formData.append("DocumentDescription", values.documentDescription);
    formData.append("File", values.file);

    const response = await client.post("/StudentDocuments/upload", formData, { onUploadProgress });
    return response.data;
  },

  /** @param {IStudentEnrollmentDocumentSubmitRequest} values */
  submitEnrollmentDocuments: async ({ studentEnrollmentId, documents }) => {
    const formData = new FormData();
    if (studentEnrollmentId) formData.append("StudentEnrollmentId", String(studentEnrollmentId));
    documents.forEach((document, index) => {
      formData.append(`Documents[${index}].StudentDocTypeId`, String(document.studentDocTypeId));
      formData.append(`Documents[${index}].Slot`, document.slot || "");
      formData.append(`Documents[${index}].File`, document.file);
    });
    const response = await client.post("/StudentDocuments/enrollment/submit", formData);
    return response.data;
  },

  download: async (studentDocId) => client.get(`/StudentDocuments/download/${studentDocId}`, {
    responseType: "blob",
  }),

  viewEnrollmentDocument: async (studentDocId, studentEnrollmentId) => client.get(`/StudentDocuments/enrollment/${studentDocId}/view`, {
    params: studentEnrollmentId ? { studentEnrollmentId } : undefined,
    responseType: "blob",
  }),

  downloadEnrollmentDocument: async (studentDocId, studentEnrollmentId) => client.get(`/StudentDocuments/enrollment/${studentDocId}/download`, {
    params: studentEnrollmentId ? { studentEnrollmentId } : undefined,
    responseType: "blob",
  }),

  /** @param {IStudentDocumentWorkflowActionRequest} values */
  updateEnrollmentDocumentWorkflow: async (values) => {
    const response = await client.post("/StudentDocuments/enrollment/workflow", values);
    return response.data;
  },

  deleteEnrollmentDocument: async (studentDocId) => {
    const response = await client.delete(`/StudentDocuments/enrollment/${studentDocId}`);
    return response.data;
  },
};
